function stripBom(text) {
  return String(text || "").replace(/^\uFEFF/, "");
}

function countDelimiterInLine(line, delimiter) {
  let count = 0;
  let inQuotes = false;
  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    const next = line[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === delimiter && !inQuotes) count += 1;
  }
  return count;
}

function detectDelimiter(text, preferred) {
  if (preferred === ";" || preferred === ",") return preferred;
  const lines = String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const sample = lines.slice(0, 5);
  let commaScore = 0;
  let semicolonScore = 0;
  sample.forEach((line) => {
    commaScore += countDelimiterInLine(line, ",");
    semicolonScore += countDelimiterInLine(line, ";");
  });

  return semicolonScore > commaScore ? ";" : ",";
}

function parseMatrix(text, delimiter) {
  const rows = [];
  let currentCell = "";
  let currentRow = [];
  let inQuotes = false;

  const input = String(text || "");
  for (let i = 0; i < input.length; i += 1) {
    const char = input[i];
    const next = input[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        currentCell += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === delimiter && !inQuotes) {
      currentRow.push(currentCell.trim());
      currentCell = "";
      continue;
    }

    if ((char === "\n" || char === "\r") && !inQuotes) {
      if (char === "\r" && next === "\n") i += 1;
      currentRow.push(currentCell.trim());
      const hasContent = currentRow.some((cell) => String(cell || "").trim() !== "");
      if (hasContent) rows.push(currentRow);
      currentRow = [];
      currentCell = "";
      continue;
    }

    currentCell += char;
  }

  if (currentCell.length > 0 || currentRow.length > 0) {
    currentRow.push(currentCell.trim());
    const hasContent = currentRow.some((cell) => String(cell || "").trim() !== "");
    if (hasContent) rows.push(currentRow);
  }

  return rows;
}

export function parseCsvText(text, options = {}) {
  const cleanText = stripBom(text);
  if (!cleanText.trim()) {
    throw new Error("Bestand is leeg of onbruikbaar.");
  }

  const delimiter = detectDelimiter(cleanText, options.delimiterPreference);
  const matrix = parseMatrix(cleanText, delimiter);

  if (matrix.length < 2) {
    throw new Error("CSV bevat geen bruikbare dataregels.");
  }

  const headers = (matrix[0] || []).map((item) => String(item || "").trim());
  const validHeaders = headers.filter((item) => item.length > 0);
  if (validHeaders.length === 0) {
    throw new Error("CSV-kopregel is onbruikbaar.");
  }

  const rows = matrix.slice(1)
    .map((values) => {
      const row = {};
      headers.forEach((header, index) => {
        if (!header) return;
        row[header] = String(values[index] || "").trim();
      });
      return row;
    })
    .filter((row) => Object.values(row).some((value) => String(value || "").trim() !== ""));

  if (rows.length === 0) {
    throw new Error("CSV bevat geen bruikbare dataregels.");
  }

  return {
    headers,
    rows,
    delimiter,
  };
}
